module.exports = __webpack_public_path__ + "img/Center-Field-Deck.6e6a8814.jpg";